<template>
  <div id="InsuredPolicyList" style="height: 100%">
    <div style="height: 28px"></div>
    <van-list
        v-model="loading"
        :finished="finished"
        finished-text=""
        @load="onLoad"
    >
      <van-cell v-for="item in list" :key="item.id" size="large" >
        <van-row type="flex" justify="space-between">
          <van-col>
            <h3 v-text="item.productName + ': '+item.planName"></h3>
          </van-col>
        </van-row>
        <van-row>
          <van-tag type="primary" size="medium">{{item.companyName}}</van-tag>
        </van-row>

        <van-row type="flex" justify="end">
          <van-col style="text-align: right" v-if="0 == item.orderStatus">
            <van-tag size="medium" color="#ff6e6c">待支付</van-tag>
          </van-col>
          <van-col span="6" justify="end" style="text-align: right" v-else-if="1 == item.orderStatus">
            <van-tag size="medium" color="#fbdd74">已支付</van-tag>
          </van-col>

          <van-col span="6" justify="end" style="text-align: right" v-else-if="2 == item.orderStatus">
            <van-tag size="medium" color="#67568c">待生效</van-tag>
          </van-col>

          <van-col span="6" justify="end" style="text-align: right" v-else-if="3 == item.orderStatus">
            <van-tag size="medium" type="success">保障中</van-tag>
          </van-col>
          <van-col span="6" justify="end" style="text-align: right" v-else-if="4 == item.orderStatus">
            <van-tag size="medium" color="#8bd3dd">已退保</van-tag>
          </van-col>
          <van-col span="6" justify="end" style="text-align: right" v-else-if="5 == item.orderStatus">
            <van-tag size="medium" color="#172c66">已失效</van-tag>
          </van-col>
          <van-col span="6" justify="end" style="text-align: right" v-else>
            <van-tag size="medium" type="primary">其他</van-tag>
          </van-col>
        </van-row>
        <p><samp>保单号：{{item.policyNo}}</samp></p>
        <p><samp>被保险人：{{item.insuredName}}</samp></p>
        <p><samp>被保险人证件号：{{item.insuredCardNo}}</samp></p>
        <p><samp>保障起期：{{item.startTime}}</samp></p>
        <p><samp>保障止期：{{item.endTime}}</samp></p>

<!--        <van-row type="flex" justify="end" v-if="0 === item.orderStatus">-->
<!--          <van-col span="6">-->
<!--            <van-button type="primary" size="large" @click="pay(item)">支付</van-button>-->
<!--          </van-col>-->
<!--        </van-row>-->

      </van-cell>
    </van-list>
    <van-empty v-if="empty.isShow" :image="empty.image" :description="empty.description" />
  </div>
</template>

<script>
import {getOrderList} from "@/api/insure";

export default {
  name:"InsuredPolicyList",
  data() {
    return {
      formDate:{
        insuredCardNo:"",
        insuredName:""
      },
      list: [],
      loading: false,
      finished: false,
      empty:{
        isShow:false,
        image:"default",
        description:"查询为空",
      },
    };
  },
  methods: {
    onLoad() {
      // 异步更新数据
      this.formDate.insuredCardNo = this.$route.query.insuredCardNo;
      this.formDate.insuredName = this.$route.query.insuredName;
      this.loading = true;
      getOrderList({
        insuredCardNo: this.formDate.insuredCardNo,
        insuredName: this.formDate.insuredName
      }).then(res => {
        if (200 === res.code) {
          if (res.data.rows && res.data.rows.length > 0) {
            this.list = res.data.rows;
          }else {
            this.empty.isShow = true;
          }
        }else {
          this.empty.isShow = true;
          this.empty.description = res.result.msg;
        }
        this.finished = true;
      }).catch(()=>{
        this.finished = true;
        this.empty.isShow = true;
        this.empty.image = "network";
        this.empty.description = "请求失败";
      });
    },
    pay(item){
      console.log(item);
    }
  },
}
</script>
